export interface ICheckoutSuccessResponse {
  mode: PaymentMode;
  productName: string;
}

export enum PaymentMode {
  Payment = 'payment',
  Subscription = 'subscription',
}
